var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4724 10.5441C10.6676 10.3489 10.6676 10.0323 10.4724 9.83704C10.2771 9.64178 9.96053 9.64178 9.76527 9.83704L8.3096 11.2927V3.5C8.3096 3.22386 8.08575 3 7.8096 3C7.53346 3 7.3096 3.22386 7.3096 3.5V11.2931L5.85355 9.83704C5.65829 9.64177 5.34171 9.64178 5.14645 9.83704C4.95118 10.0323 4.95118 10.3489 5.14645 10.5441L7.45586 12.8536C7.55783 12.9555 7.69289 13.0042 7.82648 12.9997C7.96192 12.9952 8.08371 12.9369 8.17113 12.8454L10.4724 10.5441Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDownIcon);
export default __webpack_public_path__ + "static/media/sort-down-icon.8bbef5b0488d1ccb33f2be03f104abfb.svg";
export { ForwardRef as ReactComponent };